import React, { forwardRef, useRef, useEffect } from 'react'
import { Checkbox } from '@ow/comps'

const InputCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef()
  const resolvedRef = ref || defaultRef

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate
  }, [resolvedRef, indeterminate])

  return <Checkbox className="mr-5" ref={resolvedRef} {...rest} />
})
export default InputCheckbox
